import React, { useEffect, useState } from "react";
import axios from "axios";
import AdminHeader from "../../layouts/admin-header";
import AdminFooter from "../../layouts/admin-footer";
import AdminNavBar from "../../layouts/admin-nav-bar";
import Loader from "../../loader";
import { API_URL } from "../../../config/constant";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function GeneralLeadLists({ menuAccess }) {
  const [contacts, setContacts] = useState([]);
  const [loader, setLoader] = useState(true);

  const fetchContacts = async () => {
    try {
      const res = await axios.get(API_URL + "contact/general-lead-list");
      setContacts(res.data.data || []);
    } catch (error) {
      console.error("Failed to fetch leads", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);
  
  const downloadExcel = () => {
    if (!contacts.length) return;

    const formattedData = contacts.map((row) => ({
      Name: row.name,
      PAN: row.pan,
      Email: row.email,
      Mobile: row.mobile,
      Gender: row.gender,
      Age: row.age,
      DOB: row.dob,
      "Credit Score": row.score,
      Address: [row.address1, row.address2, row.address3]
        .filter(Boolean)
        .join(", "),
      City: row.city,
      State: row.state,
      "Postal Code": row.postal_code,
      Country: row.country_code,
      "Inquiry Date": row.inquiry_date
        ? new Date(row.inquiry_date).toLocaleString()
        : "",
      "Created Date": row.created_at
        ? new Date(row.created_at).toLocaleString()
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "General Leads");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, `general_leads_${new Date().toISOString()}.xlsx`);
  };

  const getScoreBadge = (score) => {
    score = Number(score);

    if (score >= 750) return "bg-success";
    if (score >= 650) return "bg-warning text-dark";
    return "bg-danger";
  };

  return (
    <>
      {loader && <Loader />}

      <div className="layout-wrapper">
        <div className="layout-container">
          <AdminNavBar menuAccess={menuAccess} />

          <div className="adminMain-wrapper">
            <AdminHeader />

            <div className="mainContent">
              <div
                className="topHeadings"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3 style={{ margin: "10px 0" }}>General Leads</h3>

                <button
                  onClick={downloadExcel}
                  className="btn btn-success"
                  disabled={!contacts.length}
                >
                  Download Excel
                </button>
              </div>

              <div className="contentBlocks">
                <div className="sectionTable">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="card tableLead">
                          <div
                            className="tableLeadCase"
                            style={{ overflowX: "auto" }}
                          >
                            <table
                              className="table table-striped table-bordered"
                              style={{ minWidth: "1500px" }}
                            >
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Name</th>
                                  <th>PAN</th>
                                  <th>Email</th>
                                  <th>Mobile</th>
                                  <th>Gender</th>
                                  <th>Age</th>
                                  <th>DOB</th>
                                  <th>Credit Score</th>
                                  <th>Address</th>
                                  <th>City</th>
                                  <th>State</th>
                                  <th>Pincode</th>
                                  <th>Inquiry Date</th>
                                  <th>Created Date</th>
                                </tr>
                              </thead>

                              <tbody>
                                {contacts.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan="14"
                                      className="text-center"
                                    >
                                      No Leads Found
                                    </td>
                                  </tr>
                                ) : (
                                  contacts.map((row, index) => (
                                    <tr key={row.id}>
                                      <td>{index + 1}</td>

                                      <td>{row.name}</td>

                                      <td>
                                        <strong>{row.pan}</strong>
                                      </td>

                                      <td>{row.email || "-"}</td>
                                      <td>{row.mobile || "-"}</td>
                                      <td>{row.gender || "-"}</td>

                                      <td>{row.age || "-"}</td>

                                      <td>{row.dob || "-"}</td>

                                      <td>
                                        <span
                                          className={`badge ${getScoreBadge(
                                            row.score
                                          )}`}
                                        >
                                          {row.score}
                                        </span>
                                      </td>

                                      <td style={{ maxWidth: 350 }}>
                                        {[row.address1, row.address2, row.address3]
                                          .filter(Boolean)
                                          .join(", ")}
                                      </td>

                                      <td>{row.city || "-"}</td>

                                      <td>{row.state || "-"}</td>

                                      <td>{row.postal_code || "-"}</td>

                                      <td>
                                        {row.inquiry_date
                                          ? new Date(
                                              row.inquiry_date
                                            ).toLocaleString()
                                          : "-"}
                                      </td>

                                      <td>
                                        {row.created_at
                                          ? new Date(
                                              row.created_at
                                            ).toLocaleString()
                                          : "-"}
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>

                          {!loader && contacts.length > 0 && (
                            <div
                              className="card-footer"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span>
                                <strong>Total Leads:</strong> {contacts.length}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <AdminFooter />
          </div>
        </div>
      </div>
    </>
  );
}